(function($) {
  'use strict';

  // notice plugin.
  $.fn.notice = function() {
    return this.each(function() {
      var $this = $(this);
      var html = $('html');
      var close = $this.find('.js-notice-close');
      
      if (Cookies.get('notice') != '1') {
        $this.show();
        html.addClass('has-notice');
      }
      
      // Attach click event listener.
      close.on('click', function(e) {
        Cookies.set('notice', '1');
        $this.hide();
        html.removeClass('has-notice');
        e.preventDefault();
      });
    });
  };

  // header plugin.
  $.fn.header = function() {
    return this.each(function() {
      var $this = $(this);
      var button = $this.find('.js-header-button');
      var panel = $this.find('.js-header-panel');
      var links = panel.find('a');
      
      // Attach click event listener.
      button.on('click', function(e) {
        $this.toggleClass('active');
        button.toggleClass('active');
        panel.fadeToggle();
        e.preventDefault();
      });
      
      links.on('click', function(e) {
        $this.removeClass('active');
        button.removeClass('active');
        panel.fadeOut();
      });
    });
  };
  
  // io plugin.
  $.fn.io = function() {
    return this.each(function() {
      var $this = $(this);
      var items = $('.js-io-item');
      var header = $('#io-header');
      
      if ('IntersectionObserver' in window) {
        var callback = function(entries, observer) {
          var i;
          for (i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              var style = entries[i].target.getAttribute('data-io-style');
              header.attr('data-io-style', style);
            }
          }
        }
        var options = {
          threshold: 0.5
        }
        var observer = new IntersectionObserver(callback, options);
        items.each(function() {
          observer.observe(this);
        });
      }
    });
  };
  
  // io2 plugin.
  $.fn.io2 = function() {
    if ('IntersectionObserver' in window) {
      var callback = function(entries, observer) {
        var i;
        for (i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('active');
            observer.unobserve(entries[i].target);
          }
        }
      }
      var options = {
        threshold: 0.5
      }
      var observer = new IntersectionObserver(callback, options);
      var i;
      for (i = 0; i < this.length; i++) {
        observer.observe(this[i]);
      }
    } else {
      this.addClass('active');
    }
    return this;
  };
  
  // countUp plugin.
  $.fn.countUp = function() {
    return this.each(function() {
      var $this = $(this);
      var number = $this.attr('data-number');
      
      // Initialize animateNumber.
      $this.animateNumber(
        {
          number: number,
          numberStep: function(now, tween) {
            $this.text(now.toFixed(4));
          }
        },
        {
          duration: 3000
        }
      );
    });
  };
  
  // carousel4 plugin.
  $.fn.carousel4 = function() {
    return this.each(function() {
      var $this = $(this);
      var panel = $this.find('.js-carousel-4-panel');
      var panel2 = $this.find('.js-carousel-4-panel-2');
      var next = $this.find('.js-carousel-4-next');
      
      // Initialize owlCarousel.
      panel.owlCarousel({
        animateOut: 'animate__slideOutUp',
        animateIn: 'animate__slideInUp',
        dots: false,
        items: 1,
        lazyLoad: true,
        lazyLoadEager: 1,
        loop: true
      });
      panel2.owlCarousel({
        animateOut: 'animate__slideOutDown',
        animateIn: 'animate__slideInDown',
        dots: false,
        items: 1,
        lazyLoad: true,
        lazyLoadEager: 1,
        loop: true
      });
      
      // Attach click event listener.
      next.on('click', function(e) {
        panel.trigger('next.owl.carousel');
        panel2.trigger('next.owl.carousel');
        e.preventDefault();
      });
    });
  };
  
  // accordion plugin.
  $.fn.accordion = function() {
    return this.each(function() {
      var $this = $(this);
      var items = $this.find('.js-accordion-item');
      var panels = $this.find('.js-accordion-panel');
      panels.hide();
      
      items.each(function(index, value) {
        var _this = $(value);
        var panel = _this.find('.js-accordion-panel');
        
        // Attach accordion event listener.
        _this.on('accordion', function() {
          _this.addClass('active');
          panel.slideDown();
        });
      });
      
      function update() {
        items.removeClass('active');
        panels.slideUp();
        var item = items.filter('[data-id="' + window.location.hash.substring(1) + '"]');
        item.trigger('accordion');
      }
      if (window.location.hash == '') {
        items.first().trigger('accordion');
      } else {
        update();
      }
      
      // Attach hashchange event listener.
      $(window).on('hashchange', function(e) {
        update();
      });
    });
  };
  
  $(document).ready(function() {

    // Initialize notice.
    $('.js-notice').notice();
    
    // Initialize header.
    $('.js-header').header();
    
    // Initialize io.
    $('#io').io();
    
    // Initialize io2.
    $('.js-io-2').io2();
    
    // Initialize countUp.
    $('.js-countup').countUp();
    
    // Initialize owlCarousel.
    $('.js-carousel').owlCarousel({
      animateOut: 'animate__slideOutUp',
      animateIn: 'animate__slideInUp',
      autoplay: true,
      autoplayHoverPause: false,
      autoplayTimeout: 5000,
      dots: false,
      items: 1,
      lazyLoad: true,
      lazyLoadEager: 1,
      loop: true
    });
    $('.js-carousel-2').owlCarousel({
      animateOut: 'animate__slideOutDown',
      animateIn: 'animate__slideInDown',
      autoplay: true,
      autoplayHoverPause: false,
      autoplayTimeout: 5000,
      dots: false,
      items: 1,
      lazyLoad: true,
      lazyLoadEager: 1,
      loop: true
    });
    $('.js-carousel-3').owlCarousel({
      dots: false,
      items: 1,
      lazyLoad: true,
      lazyLoadEager: 1,
      loop: true,
      nav: true
    });
    
    // Initialize carousel4.
    $('.js-carousel-4').carousel4();
    
    // Initialize accordion.
    $('.js-accordion').accordion();
  });
})(jQuery);